$(function() {
  $emailCaptureModal = $('#email-capture-modal');

  if($emailCaptureModal.length) {
    setTimeout(function() {
      $emailCaptureModal.modal('show');
    }, 1500)
  }
})